import { render, staticRenderFns } from "./dex-safe.vue?vue&type=template&id=50f37bb6&scoped=true"
import script from "./dex-safe.vue?vue&type=script&lang=ts"
export * from "./dex-safe.vue?vue&type=script&lang=ts"
import style0 from "./dex-safe.vue?vue&type=style&index=0&id=50f37bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f37bb6",
  null
  
)

export default component.exports